<template>
  <el-dialog
    title="上传附件"
    :visible="true"
    width="600px"
    :before-close="() => $emit('remove')"
  >
    <div style="padding:0 50px">
      <el-form
        ref="form"
        :model="formInline"
        label-position="right"
        label-width="100px"
        :rules="rules"
      >
        <el-form-item label="文件夹名称" prop="title" ref="title">
          <el-input
            type="textarea"
            v-model="formInline.title"
            placeholder="最多输入30个字"
            maxlength="30"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <el-upload
        class="upload-demo"
        ref="upload"
        :action="fileUpload"
        :auto-upload="false"
        :data="formInline"
        :multiple="true"
        :on-success="success"
        :on-change="onchange"
        :headers="headers"
        accept=".zip, .rar, .xls, .xlsx, .doc, .docx, .ppt, .pptx, .pdf, .png, .jpg"
      >
        <el-button
          slot="trigger"
          size="small"
          type="primary"
          style="width: 100%"
        >
          上传文件
        </el-button>
        <!--          <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>-->
        <div slot="tip" class="el-upload__tip">
          支持附件：zip / rar / xls / xlsx / doc / docx / ppt /pptx / pdf / png
          / jpg 最大支持上传50M文件
          <!--          优化提示-->
          <p>
            <el-alert
              title="当前活动附件信息"
              type="info"
              :closable="false"
              style="margin:16px 0"
            >
              已上传附件数量：{{ fileNum }}，剩余可上传附件数量：{{
                canUploadNum
              }}
            </el-alert>
            <template v-if="fileList.length">
              <span style="color:red" v-if="fileList.length > canUploadNum">
                （ 待提交文件数： {{ fileList.length || 0 }} /
                {{ canUploadNum }}） 超过剩余可上传数量 请删除多余附件。
              </span>
              <span style="color:green" v-else>
                （ 待提交文件数： {{ fileList.length || 0 }} /
                {{ canUploadNum }}）
              </span>
            </template>
          </p>
        </div>
      </el-upload>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('remove')">取 消</el-button>
      <el-button
        type="primary"
        @click="confirm"
        :disabled="fileList.length > canUploadNum"
      >
        提交
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { activity, fileUpload } from '@/api/ajax';
import Config from '@/config/index';
import { getToken } from '@/tools/auth';
import { MessageBox } from 'element-ui';

export default {
  name: 'active-upload',
  props: {
    serviceActivityId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      fileUpload,
      headers: {},
      fileNum: 0, // 已有附件数量
      rules: {
        title: [{ required: true, message: '文件夹名称不能为空' }]
      },
      formInline: {
        title: ''
      },
      fileList: []
    };
  },
  computed: {
    canUploadNum() {
      return 6 - this.fileNum;
    }
  },
  methods: {
    async confirm() {
      // 本地验证表单内容
      try {
        await this.$refs.form.validate();
      } catch (e) {
        return;
      }
      // 文件非空验证
      const hasFile = this.fileList.length;
      if (!hasFile) {
        this.$message.error('请选择文件');
        return;
      }
      // 文件数量验证
      if (this.fileList.length > 6) {
        this.$message.error('文件数量最多为6个');
      }
      this.$refs.upload.submit();
    },
    async submit() {
      const files = this.fileList.reduce(
        (pre, cur) => {
          pre.fileNames.push(cur.name);
          pre.fileUrls.push(cur.response.data.fileUrl);
          return pre;
        },
        {
          fileNames: [],
          fileUrls: []
        }
      );
      let res = await activity.submitUploadFile({
        serviceActivityId: this.serviceActivityId,
        folderName: this.formInline.title,
        fileNames: files.fileNames.join(','),
        fileUrls: files.fileUrls.join(',')
      });
      //个税授权拦截
      if (res.data.messageFail) {
        let tipsContext = '';
        //已授权拦截信息
        if (res.data.noAuth.length > 0 && res.data.authList.length > 0) {
          const authList = res.data.authList.map(item => {
            return `<div style="background: #faf9f6;padding: 10px;">${item}</div>`;
          });
          //未授权拦截信息
          const noAuth = res.data.noAuth.map(item => {
            return `<div style="background: #faf9f6;padding: 10px;">${item}</div>`;
          });
          const mainStyle = `
                      <div style="text-align: left;max-height: 500px;overflow-y: auto;">
                        <div>
                          <div style="
                            background-color: #b1d7ff;
                            color: #2d87ff;
                            padding: 4px;
                            font-size: 16px;
                            display:${authList.length ? 'block' : 'none'}
                            ">
                            已授权拦截信息
                          </div>
                          ${authList.join('')}
                        </div>
                        <div>
                          <div style="
                            background-color: #b1d7ff;
                            color: #2d87ff;
                            padding: 4px;
                            font-size: 16px;
                            display:${noAuth.length ? 'block' : 'none'}
                            ">
                            未授权拦截信息
                          </div>
                          ${noAuth.join('')}
                        </div>
                      </div>
                      `;
          tipsContext = mainStyle;
        } else {
          const noAuth = res.data.noAuth.join(',');
          tipsContext = noAuth;
        }
        MessageBox.confirm(tipsContext, '授权提示', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '查看明细',
          cancelButtonText: '已知晓',
          center: true
        }).then(async () => {
          this.$emit('remove');
          this.$router.push({
            path: '/projectPersonnelManage/list',
            query: {
              tableType: 'projectSettlementTask'
            }
          });
        });

        return;
      }
      this.$refs.upload.clearFiles();
      this.$message.success('操作成功');
      this.$emit('confirm');
      this.$emit('remove');
    },
    async success(response, file, fileList) {
      const all = fileList.every(item => item.status === 'success');
      // 全部成功
      if (all) {
        this.submit();
      }
      if (response.status != 1) {
        this.$notify({
          title: '上传错误，请重新上传',
          message: response.message,
          type: 'error'
        });
        this.$refs.upload.clearFiles();
      }
    },
    onchange(file, fileList) {
      this.fileList = fileList;
    }
  },
  async created() {
    this.headers[Config.token] = getToken();
    const res = await activity.detail({
      sersviceActivityId: this.serviceActivityId
    });
    const { fileNum } = res.data.data;
    if (isNaN(+fileNum)) {
      this.fileNum = 0;
    } else {
      this.fileNum = fileNum;
    }
  }
};
</script>

<style scoped>
s .upload-demo {
  width: 100%;
}

/deep/ .el-upload {
  width: 100%;
}
/deep/ .el-textarea__inner {
  padding: 5px 50px 5px 15px !important;
}
</style>
